const preloadImages = (srcs = []) => {
  return Promise.all(
    srcs.map(src => new Promise(resolve => {
      const proxyImage = new Image();
      proxyImage.addEventListener('load', () => resolve(proxyImage.src));
      proxyImage.addEventListener('error', () => resolve(null));
      proxyImage.src = src;

      if (proxyImage.complete) {
        resolve(proxyImage.src);
      }
    }))
  ).then(results => {
    // filter out images that failed to load
    return results.filter(result => result);
  });
};

export default preloadImages;